/* SessionUnreadIndicator.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDS5Zs%7Bborder-radius%3Avar(--ds-radius-full%2C9999px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0Of8r21Y8M%7Bpadding-top%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1Znuxb1Y8M%7Bpadding-right%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1wydGW1Y8M%7Bpadding-bottom%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Zuz6Q1Y8M%7Bpadding-left%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXruDM2k%7Bbackground-color%3Avar(--ds-background-brand-bold%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
import React from 'react';
import { useIntl } from 'react-intl';
import { Box } from '@atlaskit/primitives/compiled/box';
import { messages } from './messages';
const styles = {
  dot: "_0bjKvDS5Zs _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _0KLXruDM2k _3YEZNOdnbC"
};
export type SessionUnreadIndicatorProps = {
  /** Accessible name for the dot. Defaults to the unread-session label. */
  label?: string;
  testId?: string;
};

/** Renders the unread dot with an optional caller-provided accessible label. */
export const SessionUnreadIndicator = ({
  label,
  testId
}: SessionUnreadIndicatorProps): React.JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  return <Box as="span" xcss={styles.dot} role="img" aria-label={label ?? formatMessage(messages.unreadSessionLabel)} testId={testId} />;
};